import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLike, meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {GetAttributeSetParameters} from "#template/nodes/geometry-graph/attribute-set/get-attribute-set/geometry-get-attribute-set-node"
import {
    GeometryGetAttributeSetNode,
    getAttributeSetParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/get-attribute-set/geometry-get-attribute-set-node"

export type MeshGeometryGetAttributeSetParameters = GetAttributeSetParameters<MeshGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryGetAttributeSetParameters> = {
    nodeClass: "MeshGeometryGetAttributeSet",
    validation: {
        parameters: getAttributeSetParametersSchema(meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryGetAttributeSet extends GeometryGetAttributeSetNode<2, MeshGeometryAttributeSetLikeNode> implements MeshGeometryAttributeSetLikeNode {
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
